import './app.js';
import './slider.js';
import './yakuba/app.js';

window.addEventListener("load", () => {
    const appHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight);
    appHeight();

    let accordeon = document.querySelectorAll('.accordeon');
    if(accordeon.length > 0){
        for(let i = 0; i < accordeon.length; i++){
            let currentAcc = accordeon[i];
            let btnAcc = currentAcc.querySelector('.btn-accordeon');
            btnAcc.addEventListener('click', function(){
                if(window.innerWidth < 1024){
                    currentAcc.classList.toggle('open');
                }
            });
        }
    }

    document.addEventListener('click',function(e){
        let currentNotificationButton = e.target.closest('.btn-notification-expand');
        if(currentNotificationButton) {
            currentNotificationButton.closest('.notification').classList.toggle('notification-expand');
        }
    });

    let openCart = document.querySelectorAll('.open-cart');
    let cart = document.getElementById('cart');

    if(openCart != null){
        for(let i = 0; i < openCart.length; i++){
            openCart[i].addEventListener('click', function(e){
                e.preventDefault();
                openModal(cart, this);
            });
        }
    }

    function openModal(modal, btnOpen){
        document.body.classList.add('body-overflow');
        modal.classList.add('modal-open');

        //document.addEventListener('click', func);

        let btnCloseModal = modal.querySelectorAll('.modal-dialog .btn-close-modal');
        if(btnCloseModal != null){
            for(let j = 0; j < btnCloseModal.length; j++){
                btnCloseModal[j].addEventListener('click', function(){
                    closeModal(modal);
                    //document.removeEventListener('click', func);
                });
            }
        }
        
        /*function func(e){
            var target = e.target;
            var modalDialog = modal.querySelector('.modal-dialog');
            var modalTarget = target == modalDialog || modalDialog.contains(target);
            var modalBtnOpenTarget = false;
            if(btnOpen != null){
                var modalBtnOpenTarget = target == btnOpen || btnOpen.contains(target);
            }
            var modalIsActive = modal.classList.contains('modal-open');
            
            if (!modalTarget && !modalBtnOpenTarget && modalIsActive) {
                closeModal(modal);
                document.removeEventListener('click', func);
            }   
        }*/
    }
    
    // Click on bg
    function clickBgModal() {
        document.getElementById("cart").addEventListener("click", (event) => {
            if (event.target.id == "cart") {
                closeModal(event.target);
            }
        }, false);
    }
    clickBgModal();

    function closeModal(modal){
        document.body.classList.remove('body-overflow');
        modal.classList.remove('modal-open');
    }

    let btnGridMode = document.getElementById('btn-grid-mode');
    // let gridCategoryCols = document.querySelectorAll('#grid-category .col');
    let gridCategoryCards = document.querySelectorAll('#grid-category .card');
    // let rowMode = document.getElementById('row-mode');
    // let cardMode = document.getElementById('card-mode');
    // let gridMode = document.getElementById('grid-mode');
    if(btnGridMode != null){
        // btnGridMode.addEventListener('click', function(){
        //     if(!rowMode.classList.contains('hidden')){
        //         rowMode.classList.add('hidden');
        //         cardMode.classList.add('hidden');
        //         gridMode.classList.remove('hidden');  
        //         gridCategoryCards.forEach((item) => {
        //             item.classList.add('card-sm-row');
        //             item.classList.remove('card-xs');
        //         });
        //         gridCategoryCols.forEach((item) => {
        //             item.classList.remove('col-6');
        //         });
        //     } else if(!gridMode.classList.contains('hidden')){
        //         rowMode.classList.add('hidden');
        //         cardMode.classList.remove('hidden');
        //         gridMode.classList.add('hidden'); 
        //         gridCategoryCards.forEach((item) => {
        //             item.classList.remove('card-sm-row');
        //             item.classList.add('card-xs');
        //         });
        //         gridCategoryCols.forEach((item) => {
        //             item.classList.add('col-6');
        //         });
        //     } else if(!cardMode.classList.contains('hidden')){
        //         rowMode.classList.remove('hidden');
        //         cardMode.classList.add('hidden');
        //         gridMode.classList.add('hidden'); 
        //         gridCategoryCards.forEach((item) => {
        //             item.classList.remove('card-sm-row');
        //             item.classList.remove('card-xs');
        //         });
        //         gridCategoryCols.forEach((item) => {
        //             item.classList.remove('col-6');
        //         });
        //     } 
        // });
    
        if(window.innerWidth >= 768){
            gridCategoryCards.forEach((item) => {
                item.classList.remove('card-sm-row');
                item.classList.remove('card-xs');
            });
        }

        window.addEventListener('resize', function(){
            if(window.innerWidth >= 768){
                gridCategoryCards.forEach((item) => {
                    item.classList.remove('card-sm-row');
                    item.classList.remove('card-xs');
                });
            }
        });
    }


    let header = document.getElementById('header');
    let btnMenu = document.getElementById('btn-menu');
    let langName = document.getElementById('lang-name');
    let langMenu = document.getElementById('lang-menu');
    let langMenuClose = document.getElementById('lang-menu-close');

    let infoMenuName = document.getElementById('info-menu-name');
    let infoMenuList = document.getElementById('info-menu-list');

    if(btnMenu != null){
        if(window.innerWidth < 1200){
            btnMenu.addEventListener('click', function(){
                openMenu();
            });
            menuFunctional();
        }
    }

    function openMenu(){
        if(window.innerWidth < 1200){
            if(!header.classList.contains('open-menu')){
                header.classList.add('open-menu');
                document.body.classList.add('body-overflow');

            } else {
                header.classList.remove('open-menu');
                document.body.classList.remove('body-overflow');
                menu.classList.remove('menu-overflow');

                document.querySelectorAll('.submenu-first-block').forEach(function(item){
                    item.classList.remove('open-submenu-first');
                });

                document.querySelectorAll('.has-submenu-second > a').forEach(function(item){
                    item.classList.remove('open-submenu-second-link');
                });

                document.querySelectorAll('.submenu-second').forEach(function(item){
                    item.classList.remove('open-submenu-second');
                });

                langMenu.classList.remove('open-lang-menu');

                menu.scrollTo(0,0);
            }
        }
    }

    function menuFunctional(){

        let menu = document.getElementById('menu');
        let submenuFirst = document.querySelectorAll('.has-submenu-first');
        let hasSubmenuSecond = document.querySelectorAll('.has-submenu-second');

        for(let i = 0; i < submenuFirst.length; i++){
            let currentSubmenuFirst = submenuFirst[i];
            if (currentSubmenuFirst.querySelector('a')) {
                currentSubmenuFirst.querySelector('a').addEventListener('click', function(e){
                    e.preventDefault();
                    currentSubmenuFirst.querySelector('.submenu-first-block').classList.add('open-submenu-first');
                    menu.classList.add('menu-overflow');
                });
            }
            let menuBack = currentSubmenuFirst.querySelectorAll('.menu-back');
            for(let j = 0; j < menuBack.length; j++){
                menuBack[j].addEventListener('click', function(e){
                    e.preventDefault();
                    menu.classList.remove('menu-overflow');
                    let submenuFirstBlock = document.querySelectorAll('.submenu-first-block');
                    for(let k = 0; k < submenuFirstBlock.length; k++){
                        submenuFirstBlock[k].classList.remove('open-submenu-first');
                        for(let r = 0; r < hasSubmenuSecond.length; r++){
                            hasSubmenuSecond[r].querySelector('a').classList.remove('open-submenu-second-link');
                            hasSubmenuSecond[r].querySelector('.submenu-second').classList.remove('open-submenu-second');
                        }
                    }
                }, false);
            }
        }

        for(let n = 0; n < hasSubmenuSecond.length; n++){
            let currentSubmenuSecond = hasSubmenuSecond[n];
            currentSubmenuSecond.querySelector('a').addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                let thisCurrentSubmenuSecond = this;
                let hasSubmenuSecond = document.querySelectorAll('.has-submenu-second');
                if(!thisCurrentSubmenuSecond.classList.contains('open-submenu-second-link')){
                    for(let m = 0; m < hasSubmenuSecond.length; m++){
                        hasSubmenuSecond[m].querySelector('a').classList.remove('open-submenu-second-link');
                        hasSubmenuSecond[m].querySelector('.submenu-second').classList.remove('open-submenu-second');
                    }
                    thisCurrentSubmenuSecond.classList.add('open-submenu-second-link');
                    currentSubmenuSecond.querySelector('.submenu-second').classList.add('open-submenu-second');
                } else {
                    thisCurrentSubmenuSecond.classList.remove('open-submenu-second-link');
                    currentSubmenuSecond.querySelector('.submenu-second').classList.remove('open-submenu-second');
                }
            });
        }
        if (langName) {
            langName.addEventListener('click', function(){
                langMenu.classList.add('open-lang-menu');
            });
            if (langMenuClose) {
                langMenuClose.addEventListener('click', function(e){
                    e.preventDefault();
                    langMenu.classList.remove('open-lang-menu');
                });
            }
        }   
    }

    function setSubmenuHeight(element) {
        const submenuSecond = element.querySelector('.submenu-second-block .submenu-second');
        if (submenuSecond) {
            element.parentElement.style.height = submenuSecond.offsetHeight + 120 + 'px';
        }
    }
    
    if(window.innerWidth >= 1200){
        let doubleSubmenuItem = document.querySelectorAll('.has-double-submenu .has-submenu-second');
        for(let i = 0; i < doubleSubmenuItem.length; i++){
            let currentLink = doubleSubmenuItem[i].querySelector('a');
            doubleSubmenuItem[0].classList.add('hovered');
            
            setSubmenuHeight(doubleSubmenuItem[0]);

            currentLink.addEventListener('mouseover', function(){
                for(let j = 0; j < doubleSubmenuItem.length; j++){
                    doubleSubmenuItem[j].classList.remove('hovered');
                }
                doubleSubmenuItem[i].classList.add('hovered'); 

                setSubmenuHeight(doubleSubmenuItem[i]);
            });
        }
        if (langName) {
            langName.addEventListener('click', function (e) {
                langMenu.classList.toggle('open-lang-menu');
            });
        }

        document.addEventListener('click', function(e){
            var target = e.target;

            if (langName) {
                var langNameTarget = target == langName || langName.contains(target);
                var langMenuTarget = target == langMenu || langMenu.contains(target);
                var langMenuIsOpen = langMenu.classList.contains('open-lang-menu');
                if (!langNameTarget && !langMenuTarget && langMenuIsOpen) {
                    langMenu.classList.remove('open-lang-menu');
                }
            }

        });

        infoMenuName.addEventListener('click', function(e){
            infoMenuList.classList.toggle('open-info-menu');
        });

        document.addEventListener('click', function(e){
            var target = e.target;
            var infoMenuNameTarget = target == infoMenuName || infoMenuName.contains(target);
            var infoMenuListTarget = target == infoMenuList || infoMenuList.contains(target);
            var infoMenuListIsOpen = infoMenuList.classList.contains('open-info-menu');
            if(!infoMenuNameTarget && !infoMenuListTarget && infoMenuListIsOpen){
                infoMenuList.classList.remove('open-info-menu');
            }
        });

    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            var thisElement = document.querySelector(this.getAttribute('href'));
            var pageYOffset = window.pageYOffset;
            var thisElementBound = thisElement.getBoundingClientRect();
            var thisElementTop = thisElementBound.top;
            var constVal = 150;
            window.scrollTo({
                top: pageYOffset + thisElementTop - constVal,
                behavior: 'smooth'
            });
        });
    });

    let footerMenuCol = document.querySelectorAll('.footer-menu-col');
    for(let i = 0; i < footerMenuCol.length; i++){
        let currentMenuCol = footerMenuCol[i];
        let currentMenuTitle = currentMenuCol.querySelector('.footer-menu-title');
        currentMenuTitle.addEventListener('click', function(){
            currentMenuCol.classList.toggle('open-menu');
        });
    }

    let checkoutCrossing = document.querySelectorAll('.checkout-crossing');
    let checkoutCrossingPanel = document.querySelectorAll('.checkout-crossing-panel');
    if(checkoutCrossing != null){
        for(let i = 0; i < checkoutCrossing.length; i++){
            checkoutCrossing[i].addEventListener('click', function(){
                let thisCheckoutCrossing = this;
                let dataCheckout = this.getAttribute('data-checkout');
                for(let j = 0; j < checkoutCrossingPanel.length; j++){
                    if(dataCheckout == checkoutCrossingPanel[j].getAttribute('data-checkout')){
                        checkoutCrossingPanel[j].classList.add('crossing-panel-visible');
                        thisCheckoutCrossing.classList.add('hidden');
                    }
                }
            });
        }
        for(let m = 0; m < checkoutCrossingPanel.length; m++){
            let currentCheckoutCrossingPanel = checkoutCrossingPanel[m];
            let closeCrossingPanel = checkoutCrossingPanel[m].querySelectorAll('.close-crossing-panel');
            for(let n = 0; n < closeCrossingPanel.length; n++){
                closeCrossingPanel[n].addEventListener('click', function(){
                    currentCheckoutCrossingPanel.classList.remove('crossing-panel-visible');
                    for(let k = 0; k < checkoutCrossing.length; k++){
                        if(currentCheckoutCrossingPanel.getAttribute('data-checkout') == checkoutCrossing[k].getAttribute('data-checkout')){
                            checkoutCrossing[k].classList.remove('hidden');
                        }
                    }
                });
            }
        }
    }

    let btnUserTab = document.querySelectorAll('.btn-user-tab');
    let checkoutPanelUser = document.querySelectorAll('.checkout-panel-user');
    if(btnUserTab != null){
        for(let i = 0; i < btnUserTab.length; i++){
            btnUserTab[i].addEventListener('click', function(){
                for(let k = 0; k < btnUserTab.length; k++){
                    btnUserTab[k].classList.add('unactive');
                }
                this.classList.remove('unactive');
                let thisUserType = this.getAttribute('data-user');
                for(let j = 0; j < checkoutPanelUser.length; j++){
                    checkoutPanelUser[j].classList.add('hidden');
                    if(checkoutPanelUser[j].getAttribute('data-user') == thisUserType){
                        checkoutPanelUser[j].classList.remove('hidden');
                    }
                }
            });
        }
    }

    let filterOpen = document.querySelectorAll('.filter-open');
    let filterModal = document.getElementById('filter');
    if(filterOpen.length > 0){
        for(let i = 0; i < filterOpen.length; i++){
            filterOpen[i].addEventListener('click', function(e){
                e.preventDefault();
                openModal(filterModal, this);
            });
        }
        
        let filterOpenSecondary = document.querySelectorAll('.filter-open-secondary');
        let filterSecondaryBlock = document.querySelectorAll('.filter-secondary-block');
        let btnBackFilter = document.querySelectorAll('.btn-back-filter');
        let btnCloseFilter = document.querySelectorAll('.btn-close-filter');
        let filterMainBLock = document.getElementById('filter-main-block');

        if(filterOpenSecondary.length > 0){
            for(let j = 0; j < filterOpenSecondary.length; j++){
                filterOpenSecondary[j].addEventListener('click', function(){
                    let thisDataFilter = this.getAttribute('data-filter');
                    for(let k = 0; k < filterSecondaryBlock.length; k++){
                        if(filterSecondaryBlock[k].getAttribute('data-filter') == thisDataFilter){
                            filterSecondaryBlock[k].classList.remove('hidden-filter');
                        }
                    }
                    filterMainBLock.classList.add('filter-main-height');
                });
            }
            for(let m = 0; m < btnBackFilter.length; m++){
                btnBackFilter[m].addEventListener('click', function(){
                    for(let k = 0; k < filterSecondaryBlock.length; k++){
                        filterSecondaryBlock[k].classList.add('hidden-filter');
                    }
                    filterMainBLock.classList.remove('filter-main-height');
                });
            }
            for(let n = 0; n < btnCloseFilter.length; n++){
                btnCloseFilter[n].addEventListener('click', function(){
                    filterMainBLock.classList.remove('filter-main-height');
                    for(let k = 0; k < filterSecondaryBlock.length; k++){
                        filterSecondaryBlock[k].classList.add('hidden-filter');
                    }
                });
            }
        }
    }
}, false);

